export default __webpack_public_path__ + "static/media/quizScreenImg.d875e0d3.jpg";